import type { FC, ReactElement } from 'react'
import React from 'react'

import { useTheme } from 'styled-components'
import { getDataSelector } from '@vfuk/core-base-props'

import * as Styled from './styles/Logo.style'

import type { Theme } from '@vfuk/core-themes'
import type { LogoProps } from './Logo.types'

const Logo: FC<LogoProps> = ({ inverse, dataSelectorPrefix }: LogoProps): ReactElement => {
  const { brandLogo, inverseBrandLogo } = useTheme() as Theme

  return (
    <Styled.LogoWrapper data-selector={getDataSelector(dataSelectorPrefix)}>
      {inverse ? inverseBrandLogo() : brandLogo()}
    </Styled.LogoWrapper>
  )
}

export default Logo
